import React from 'react'
import Heading from '../components/Heading'
import ResponsiveTable from '../components/ResponsiveTable'
import ModuleWithLoader from '../components/ModuleWithLoader'
import DataSource from '../DataSource'
import FancySelect from '../elements/FancySelect/FancySelect'
import AjaxLoader from '../components/AjaxLoader'
import Pagination from '../components/Pagination'
import StreamCsv from '../components/StreamCsv'

class DailyUsage extends React.Component {
    constructor (props) {
        super(props)

        this.months = { 1: 'Jan', 2: 'Feb', 3: 'Mar', 4: 'Apr', 5: 'May', 6: 'Jun', 7: 'Jul', 8: 'Aug', 9: 'Sep', 10: 'Oct', 11: 'Nov', 12: 'Dec' }

        this.state = {
            isLoaded: false,
            hasError: false,
            isLoadingBreakdown: false,
            isLoadingDate: false,
            isNotAnytime: false,
            usageDaily: [],
            searchResults: [],
            paginatedResults: [],
            page: 1,
            pageCount: 0,
            resultQty: 35,
            search: '',
            month: null,
            year: null,
            apiUrl: ''
        }
    }

    componentDidMount () {
        this.getData(false)
    }

    getData (includeDates = true) {
        this.setExportUrl(includeDates)
        const checkDates = new Promise((resolve, reject) => {
            let url = `/api/getBroadbandDailyUsage/${this.props.serviceId}`
            if (includeDates) {
                this.setDatesIfNull(() => {
                    url += `/${this.state.month}/${this.state.year}`
                    resolve(url)
                })
            } else {
                resolve(url)
            }
        })

        checkDates.then(url => {
            DataSource.getData(url, result => {
                this.setState({
                    usageDaily: result.usageDaily,
                    isNotAnytime: result.isNotAnytime,
                    paginatedResults: this.paginateResults(result.usageDaily)
                }, () => {
                    this.setPageNumber(result.usageDaily)
                    this.setState({ isLoaded: true, isLoadingBreakdown: false })
                })
            }, () => {
                this.setState({ hasError: true, isLoaded: true })
            })
        })
    }

    setExportUrl (includeDates) {
        const checkDates = new Promise((resolve, reject) => {
            let url = `/api/exportUsageCsv/broadband/${this.props.serviceId}`
            if (includeDates) {
                this.setDatesIfNull(() => {
                    url += `/${this.state.month}/${this.state.year}`
                    resolve(url)
                })
            } else {
                resolve(url)
            }
        })

        checkDates.then(url => {
            this.setState({ exportUrl: url })
        })
    }

    setDatesIfNull (callback) {
        const today = new Date()
        this.setState({
            month: this.state.month ? this.state.month : this.months[today.getMonth() + 1],
            year: this.state.year ? this.state.year : today.getFullYear()
        }, () => callback())
    }

    setPageNumber (results) {
        this.setState({
            pageCount: Math.max(1, Math.ceil(results.length / this.state.resultQty))
        })
    }

    paginateResults (results) {
        const start = parseInt((this.state.page - 1) * this.state.resultQty)
        const end = start + parseInt(this.state.resultQty)

        return results.slice(start, end)
    }

    handleChangePage (event) {
        event.preventDefault()
        const page = event.target.dataset.page
        this.setState({ isLoadingBreakdown: true })
        this.scrollToTop()

        setTimeout(() => {
            this.setState({ page: page })
        }, 200)
    }

    handleChangeMonth (value) {
	    if (value !== this.state.month) {
            this.setState({ month: value, search: '', isLoadingBreakdown: true }, this.getData.bind(this))
        }
    }

    handleChangeYear (value) {
	    if (value !== this.state.year) {
            this.setState({ year: value, search: '', isLoadingBreakdown: true }, this.getData.bind(this))
        }
    }

    scrollToTop () {
        window.scrollTo(this.breakdown.offsetLeft, this.breakdown.offsetTop - 50)
    }

    yearData () {
        const years = []
        const today = new Date()
        const thisYear = today.getFullYear()

        for (let i = (thisYear - 10); i <= thisYear; i++) {
            years.push(i)
        }

        return years.reverse()
    };

    render () {
	    const headings = this.state.isNotAnytime ? ['Date', 'Total peak', 'Total off-peak', 'Uploads', 'Downloads', 'Total data usage'] : ['Date', 'Uploads', 'Downloads', 'Total data usage']
        const usageData = {
            headings: headings,
            rows: this.state.paginatedResults
        }
        const hasResults = this.state.paginatedResults.length > 1
        const Results = () => {
            if (this.state.isLoadingBreakdown) {
                return <AjaxLoader />
            } else if (hasResults) {
			    const startDate = this.state.paginatedResults[0][0]
			    const endDate = this.state.paginatedResults.slice(-2)[0][0]
			    return (
    <React.Fragment>
                        <p className='text-center font-small my-2 mb-4 mb-lg-2'>Showing results from <span className='bold'>{startDate}</span> to <span className='bold'>{endDate}</span> (your billing cycle)</p>
                        <ResponsiveTable data={usageData} minWidthMobile={500} />
                    </React.Fragment>
                )
            } else {
                return <div className='row-error text-center mt-4'>No items to display</div>
            }
        }

        const filename = () => {
            if (this.state.month && this.state.year) {
                return `${this.state.month}-${this.state.year}-data-usage`
            }

            const today = new Date()
            return `${this.months[today.getMonth() + 1]}-${today.getFullYear()}-data-usage`
        }

        return (
            <div className='broadband-usage-details module'>
                <Heading title='Daily usage' />
                <ModuleWithLoader isLoaded={this.state.isLoaded} hasError={this.state.hasError} className='p-4'>
                    <div className='row'>
                        <div className='col-12 col-md-8 offset-md-2 text-center'>
                            <p>You can monitor your daily data usage here. Looking at your daily data can help you identify any data usage spikes and help you learn more about your data usage habits. Simply choose a date and your daily usage records will display for that billing cycle below.</p>
                        </div>
                    </div>

                    <div className='breakdown' ref={el => this.breakdown = el}>
                        <div className='row'>
                            <div className='col-12'>
                                <h1 className='text-center'>Daily usage since start of billing cycle</h1>
                            </div>
                        </div>

                        <div className='row mb-2'>
                            <div className='col-12 col-md-6 form-control text-center text-md-left date-selection '>
                                <label>Select month to display</label>
                                <div>
                                    <FancySelect
                                        label='Month'
                                        list={['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']}
                                        value={(this.state.month)}
                                        setValue={this.handleChangeMonth.bind(this)}
                                    />
                                    <FancySelect
                                        label='Year'
                                        list={this.yearData()}
                                        value={this.state.year}
                                        setValue={this.handleChangeYear.bind(this)}
                                    />
                                </div>
                            </div>
                            {hasResults
                                ? <div className='col-12 col-md-6 my-2 text-center text-lg-right'>
                                    <StreamCsv
                                        key={`${this.state.month}${this.state.year}`}
                                        apiUrl={this.state.exportUrl}
                                        outputFilename={filename()}
                                        gaEvent='ExportUsageCsvBroadband'
                                    />
                                  </div>
                                : ''}
                        </div>
                        {Results()}
                        <Pagination page={this.state.page} pageCount={this.state.pageCount} handleClick={this.handleChangePage.bind(this)} />
                    </div>
                </ModuleWithLoader>
            </div>
        )
    }
}

export default DailyUsage



// WEBPACK FOOTER //
// ./resources/js/modules/DailyUsage.js